export const AllDashboardRoutes = {
  index: "/",
  dashboard: "/dashboard",
};
